import React from "react";
import PropTypes from "prop-types";
import { Modal as SemanticModal } from "semantic-ui-react";
import { isFunction } from "@cayuse/shared-react.utils.type-checks";
import { useDictionary } from "hooks";
import Icon from "@cayuse/shared-react.components.icon";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";
import Button from "@cayuse/shared-react.components.button";
import Modal from "@cayuse/shared-react.components.modal";

import styles from "./styles.css";


const ConfirmationModal = ({
	className,
	cancelButtonLabel,
	confirmButtonLabel,
	icon,
	message,
	onCancel,
	onConfirm,
	title,
	visible,
	cancelButtonOptions,
	confirmButtonOptions,
}) => {
	const dictionary = useDictionary("common.confirmationModal");

	const handleConfirm = () => {
		if (isFunction(onConfirm)) {
			onConfirm();
		}
	};

	const handleCancel = () => {
		if (isFunction(onCancel)) {
			onCancel();
		}
	};

	return (
		<Modal
			data-testid="confirmation-modal"
			className={`${styles.transparentModal} ${className}`}
			open={visible}
			onClose={handleConfirm}
			closeOnEscape={false}
			closeIcon={false}
			closeOnDimmerClick={false}
			ariaLabel={title}
		>
			<SemanticModal.Header className={`ui header ${styles.transparentModalHeader}`}>
				<h2>{title}</h2>
			</SemanticModal.Header>
			<SemanticModal.Content className={styles.transparentModalContent}>
				{icon && <div>
					<Icon
						aria-hidden="true"
						className={styles.transparentModalContentIcon}
						name={icon}
					/>
				</div>}
				<div>
					{message}
				</div>
			</SemanticModal.Content>
			<VerticalSpacing/>
			<SemanticModal.Actions className={styles.transparentModalActions}>
				{isFunction(onCancel) &&
				<Button
					secondary
					className={styles.cancelButton}
					data-testid="confirmation-modal-cancel-button"
					onClick={handleCancel}
					{...(cancelButtonOptions || {})}
				>
					{cancelButtonLabel || dictionary.cancelButtonLabel || "Cancel"}
				</Button>}

				{isFunction(onConfirm) &&
				<Button
					data-testid="confirmation-modal-confirm-button"
					onClick={handleConfirm} 
					{...(confirmButtonOptions || { success: true })}
				>
					{confirmButtonLabel || dictionary.confirmButtonLabel || "Confirm"}
				</Button>}
			</SemanticModal.Actions>
		</Modal>
	);
};

ConfirmationModal.propTypes = {
	icon: PropTypes.string,
	message: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.string
	]),
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
	title: PropTypes.string,
	visible: PropTypes.bool,
	cancelButtonOptions: PropTypes.object,
	confirmButtonOptions: PropTypes.object
};

export default ConfirmationModal;
